import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppStateFacade } from '@app-state';
import { UiFolderTreeModalComponent } from '@components/ui-folder-tree-modal/ui-folder-tree-modal.component';
import { FolderTreeStateService } from '@components/ui-folder-tree/ui-folder-tree-state';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services';

import {
    combineLatest,
    of,
    Subject,
} from 'rxjs';
import {
    filter,
    map,
    switchMap,
    takeUntil,
} from 'rxjs/operators';

@Component({
    selector: 'ui-folder-picker',
    templateUrl: './ui-folder-picker.component.html',
    styleUrls: ['./ui-folder-picker.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        FolderTreeStateService,
    ],
})
export class UiFolderPickerComponent implements OnDestroy {
    public currentFolderName$ = this._appState.user.folder.value$.pipe(
        switchMap(folder => !this._appState.user.folder.hasAny
            ? this._translateService.stream('folder_picker_no_folder')
            : of(folder!.displayName)),
    );

    public currentFolderType$ = combineLatest([
        this._appState.user.folder.type$,
        this._appState.language.value$,
    ])
        .pipe(
            map(([type]) => !type ? null : this._translateService.instant(`folder_picker_tooltip_${type}`)),
        );

    private _foldersModal?: MatDialogRef<any>;
    private _destroyed$ = new Subject();

    constructor(
        private _modalService: ModalService,
        private _appState: AppStateFacade,
        private _folderTreeState: FolderTreeStateService,
        private _translateService: TranslateService,
    ) {
        this._appState.user.value$.pipe(
            filter(u => !u && !!this._foldersModal),
            takeUntil(this._destroyed$),
        ).subscribe(
            () => this._foldersModal!.close(),
        );
    }

    public ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    public openFoldersModal() {
        if (this._foldersModal) {
            return;
        }

        this._foldersModal = this._modalService.openModal(UiFolderTreeModalComponent, this._folderTreeState, {
            allowBackdropClose: true,
            additionalClasses: ['ui-folder-tree-modal'],
            position: {
                right: '150px',
                top: '80px',
            },
            disableBackdrop: true,
        });

        this._foldersModal.afterClosed().subscribe(() => this._foldersModal = undefined);
    }
}
